<template>
  <div>
    <form @submit.prevent="validateBeforeSubmit('formWebhookSettings')" data-vv-scope="formWebhookSettings">

      <description-webhook-settings />

      <div class="col-md-8">

        <select-webhook-settings />

        <div class="row">
          <authorized-link tag="show_setting">
            <label class="ls-label">
              <span class="ls-label-text col-xs-12">
                {{ $t('settings.main.webhook_setting_url') }}
                <popover class="mb-1" :position="'right'">
                  <div slot="content">{{ $t('settings.tooltip.webhook_setting') }}</div>
                </popover>
              </span>
              <div class="col-xs-12 col-md-7 col-sm-7 col-lg-7">
                <input
                  type="url"
                  v-model="webhookSetting.value"
                  :required="false"
                  :min="1"
                  :max="30"
                  :name="$t('settings.main.webhook_setting_value')"
                  :placeholder="$t('settings.placeholder.webhook_setting_value')" />
              </div>
            </label>
          </authorized-link>
        </div>

      </div>

      <button-submit />

    </form>
  </div>
</template>
<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import ButtonSubmit from './ButtonSubmit'
  import DescriptionWebhookSettings from './DescriptionWebhookSettings'
  import SelectWebhookSettings from './SelectWebhookSetting'
  import Popover from 'src/app/components/shareds/popover/Popover'

  export default {
    components: { ButtonSubmit, DescriptionWebhookSettings, SelectWebhookSettings, Popover },
    methods: {
      ...mapActions(['loadWebhookSettings', 'loadWebhookSetting', 'updateWebhookSetting']),
      ...mapMutations(['clearFlash']),
      validateBeforeSubmit (scope) {
        this.clearFlash()
        this.$validator.validateAll(scope).then(success => {
          if (!success) return
          this.$parent.submitForm()
        })
      }
    },
    computed: {
      ...mapGetters(['webhookSetting'])
    }
  }
</script>

<style lang="css" scoped>
  .mb-1 {
    margin-bottom: 0.5vh;
  }
</style>




// WEBPACK FOOTER //
// WebhookSettings.vue?1f57dd72